<phms-case-context-record-grid
  data-testid="case-context-violations-panel"
  [appTerminologyIdentity]="sectionUsage.heading"
  [heading]="sectionText.heading()"
  itemLabelSingular="violation"
  itemLabelPlural="violations"
  [records]="records"
  [state]="state"
  [columnDefs]="columnDefs"
  [agGridOptions]="agGridOptions"
  [stateCopy]="{
    loadingText: 'Loading violations...',
    emptyText: 'No violations on file.',
    errorText: 'Violations are temporarily unavailable.',
  }"
></phms-case-context-record-grid>
